import { j as p } from "./jsx-runtime-3tyXYecC.mjs";
import { useMemo as u } from "react";
import { c as f } from "./index-DkZ16bcJ.mjs";
import { d as C } from "./index-DspsydPg.mjs";
import { b as a, C as c } from "./enums-BtUzbEmn.mjs";
import { c as g } from "./capitalize-iyaz5rT3.mjs";
import { m as y } from "./tss-DN0acMKN.mjs";
import { M as S, d as x } from "./constants-CnFYFetN.mjs";
const l = ["bottom", "left", "right", "top"], d = C.createLogger("@fabric/card | <Content />");
function j(t, { canOverflow: s, flex: o, spacingOverrides: e } = {}) {
  return f(t, {
    [`${t}--noOverflow`]: s === !1,
    [`${t}--customSpacing`]: !!(typeof e == "object" && Object.keys(e).length),
    [`${t}--flexColumn`]: o === a.COLUMN,
    [`${t}--flexRow`]: o === a.ROW
  });
}
function v(t = {}) {
  return Object.entries(t || {}).reduce((s, [o, e]) => {
    const i = l.includes(o), r = Object.keys(c).some((n) => c[n] === e);
    return i || d.warn(`An invalid spacing override key was supplied. Expected one of "${l.join('", ')}" but got ${o}.`), r || d.warn(
      'An invalid spacing override value was supplied. Use the "ContentSpacing" enum to ensure a valid value is used.'
    ), i && r && e !== c.CUSTOM && (s[`padding${g(o)}`] = e), s;
  }, {});
}
const $ = y()((t, { canOverflow: s, flex: o, spacingOverrides: e }) => {
  const { mode: i } = t, r = o ? "flex" : void 0;
  let n;
  return o === a.COLUMN ? n = "column" : o === a.ROW ? n = "row" : n = void 0, {
    root: {
      color: i === S.Dye ? x.main : void 0,
      display: r,
      flexDirection: n,
      overflow: s ? "visible" : "hidden",
      padding: e ? void 0 : "32px 48px"
    }
  };
}), b = ({ canOverflow: t = !0, children: s, flex: o, spacingOverrides: e }) => {
  const { className: i, style: r } = u(
    () => ({
      className: j("fab-CardContent", { canOverflow: t, flex: o, spacingOverrides: e }),
      style: v(e)
    }),
    [t, o, e]
  ), { classes: n, cx: m } = $({
    canOverflow: t,
    flex: o,
    spacingOverrides: e
  });
  return /* @__PURE__ */ p.jsx("div", { className: m(n.root, i), style: r, children: s });
};
b.displayName = "Content";
export {
  b as C
};
//# sourceMappingURL=content-iXOVBfdp.mjs.map
